import { NS_SVG } from "../constants";
import { SVG_GetUniqueID } from "./SVG_GetUniqueID";
import { SVG_GetDefs } from "./SVG_GetDefs";
import { SVG_ShiftRect } from "./SVG_ShiftRect";

export function SVG_CreateCircleMask(clipRect, cx, cy, r, attachTo, svgElement) {
  SVG_ShiftRect(clipRect, svgElement);

  var maskShape = document.createElementNS(NS_SVG, "circle");
  maskShape.setAttribute("cx", cx.toString());
  maskShape.setAttribute("cy", cy.toString());
  maskShape.setAttribute("r", r.toString());
  maskShape.setAttribute("fill", "white");

  var mask = document.createElementNS(NS_SVG, "mask");
  var maskID = SVG_GetUniqueID("mask-circle-");
  mask.setAttribute("id", maskID);
  // Set explicit bounds in userSpaceOnUse to ensure mask covers the circle area
  mask.setAttribute("maskUnits", "userSpaceOnUse");
  mask.setAttribute("x", (cx - r).toString());
  mask.setAttribute("y", (cy - r).toString());
  mask.setAttribute("width", (r * 2).toString());
  mask.setAttribute("height", (r * 2).toString());
  mask.appendChild(maskShape);

  var defs = SVG_GetDefs(svgElement);
  defs.appendChild(mask);

  if (attachTo !== null) {
    var s = "url(#" + maskID + ")";
    attachTo.setAttribute("mask", s);

    // also need to have circle outline
  }

  return maskID;
}
